import { render, staticRenderFns } from "./P2PDealsExtra.vue?vue&type=template&id=06f25366&scoped=true&"
import script from "./P2PDealsExtra.vue?vue&type=script&lang=js&"
export * from "./P2PDealsExtra.vue?vue&type=script&lang=js&"
import style0 from "./P2PDealsExtra.vue?vue&type=style&index=0&id=06f25366&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f25366",
  null
  
)

export default component.exports